module.exports = __webpack_public_path__ + "img/19200.35fbfe16.jpg";